import { Box, Button, ButtonGroup, Tooltip } from '@mui/material'
import PropertiesViewer from './PropertiesViewer'
import HighlightsCard from '../$HighlightsCard'
import { Cancel, Info } from '@mui/icons-material'
import { ICustomerBasic, ICustomerSummary } from '../../Models/Customer'
import { useEffect, useState } from 'react'
import CancelTransactionModal from '../Modals/cancelTransactionModal'
import { TRANSACTION_STATUS, TRANSACTION_TYPES } from '../../utils/constant'
import UploadIcon from '@mui/icons-material/Upload';
import CustomerPanUpload from '../_CustomerSetup/CustomerPanUpload'
import { getCustomer } from '../../services/Customer'
import useService from '../../hooks/useService'
import Modal from '../Modals'

interface THighlightsCardAndCustomerDetailsProps {
    customerConfig: ICustomerBasic,
    globalTransactionNumber: string,
    status: string
    inboundId?: string
    transactionType:string
    onSuccessCancelTransaction?: (transactionId:string) => any
}

const nonCancellableTransactionStatus = [TRANSACTION_STATUS.INBOUND_INITIATED, TRANSACTION_STATUS.DELIVERY_INITIATED, TRANSACTION_STATUS.COMPLETED, TRANSACTION_STATUS.PAYMENT_INITIATED, TRANSACTION_STATUS.CANCELLED]
const nonCancellableTransactions = [TRANSACTION_TYPES.MINTED_SALES, TRANSACTION_TYPES.PURITY_TESTING]

const UserDetails: { id: keyof ICustomerBasic, value: string, label: string }[] = [
    {
        id: 'displayName',
        label: 'Name',
        value: ''
    },
    {
        id: 'fullName',
        label: 'Full Name',
        value: ''
    },
    {
        id: 'walletBalance',
        label: 'Available Balance',
        value: ''
    },
    {
        id: 'mobileNumber',
        label: 'Mobile Number',
        value: ''
    },
    {
        id: 'emailAddress',
        label: 'Email Address',
        value: ''
    },
    {
        id: 'customerRefNo',
        label: 'Customer Ref No',
        value: ''
    },
    {
        id: 'accountStatus',
        label: 'Account Status',
        value: ''
    },
    {
        id: 'dgCustomerRefNo',
        label: 'Dg Customer Ref No',
        value: ''
    },
    {
        id: 'dob',
        label: 'Date of Birth',
        value: ''
    },
    {
        id: 'gender',
        label: 'Gender',
        value: ''
    },
    {
        id: 'gstin',
        label: 'GST Number',
        value: ''
    },
    {
        id: 'kycStatus',
        label: 'KYC Status',
        value: ''
    },
    {
        id: 'isCorporate',
        label: 'Is Business Account',
        value: ''
    },
    {
        id: 'pan',
        label: 'PAN Number',
        value: ''
    },
    {
        id: 'maritalStatus',
        label: 'Marital Status',
        value: ''
    },
    {
        id: 'userType',
        label: 'User Type',
        value: ''
    },
    {
        id: 'buybackMetalReturnPercentage',
        label: 'Buyback Metal Return Percentage',
        value: ''
    },
    {
        id: 'buysellMetalReturnPercentage',
        label: 'Buysell Metal Return Percentage',
        value: ''
    },
    {
        id: 'purityVerificationCharges',
        label: 'Purity Verification Charges',
        value: ''
    },
    {
        id: 'jobworkMetalReturnPercentage',
        label: 'Job Work Metal Return Percentage',
        value: ''
    },
    {
        id: 'refiningCharges',
        label: 'Refining Charges',
        value: ''
    },
    {
        id: 'nationality',
        label: 'Nationality',
        value: ''
    },
    {
        id: 'partnerId',
        label: 'Partner Id',
        value: ''
    },
    {
        id: 'profession',
        label: 'Profession',
        value: ''
    },
    {
        id: 'mtsIsTDSApplicable',
        label: 'TCS/TDS applicability',
        value: ''
    }
]

const getHightlights = ({ customerConfig, globalTransactionNumber, status, inboundId }: { customerConfig: ICustomerBasic, globalTransactionNumber: string, status: string, inboundId?: string}) => {
    let availableBalance = Number(customerConfig.walletBalance) || 0
    const highlights = [
        { label: globalTransactionNumber && /^GT\d+$/.test(globalTransactionNumber) ? 'Transaction Number' : 'Order ID', value: globalTransactionNumber },
        { label: 'Status', value: status },
        { label: 'Customer', value: customerConfig.fullName },
        { label: 'Available Balance', value: Number(availableBalance.toFixed(2)) },
    ]
    if(customerConfig.mtsIsTDSApplicable==null) highlights.push({label : 'TCS/TDS Applicability',value : 'Not Declared'})
    if(customerConfig.mtsIsTDSApplicable=="0") highlights.push({label : 'TCS/TDS Applicability',value : 'TCS Applicable'})
    if(customerConfig.mtsIsTDSApplicable=="1") highlights.push({label : 'TCS/TDS Applicability',value : 'TDS Applicable'})
    if (customerConfig.gstin) highlights.push({ label: 'GSTIN', value: customerConfig.gstin })
    if (customerConfig.pan) highlights.push({ label: 'PAN', value: customerConfig.pan })
    if (inboundId) highlights.push({ label: 'Inbound Header', value: inboundId })
    if(customerConfig.refiningCharges == null)  highlights.push({label : 'Refining Charges',value : ''})
        else highlights.push({label : 'Refining Charges',value : customerConfig.refiningCharges})




    return highlights
}
const HighlightsCardAndCustomerDetails = (props: THighlightsCardAndCustomerDetailsProps) => {
    const { customerConfig, globalTransactionNumber, status, inboundId, onSuccessCancelTransaction, transactionType } = props;
    const [showCustomerDetails, setShowCustomerDetails] = useState<boolean>(false)
    const [showCancelModal, setShowCancelModal] = useState<boolean>(false)
    // const [showPanForm, setShowPanForm] = useState<ICustomerSummary | boolean>(false)
    const [showPanForm, setShowPanForm] = useState<boolean>(false)
    const {execute} = useService()
    const fetchCustomer = () => execute(()=> getCustomer({customerRefNo:customerConfig.customerRefNo!}))
    
    const showUserDetails=()=>{
    return  UserDetails.map(user => {
        if(user.id === "displayName"){
            if (!customerConfig.displayName) {
                user.value = customerConfig.fullName
            } else  {
                user.value = customerConfig.displayName
            }
        } else if(user.id === "pan"){
            if(!customerConfig.pan) {
                user.value = customerConfig?.kycInfo?.nameProofDocNo
            } else {
                user.value = customerConfig?.pan
            }
        } else {  user.value = customerConfig[user.id as keyof ICustomerBasic] }
            return user 
        })
    }

    useEffect(() => {
        if(customerConfig.customerRefNo)fetchCustomer()

    }, [customerConfig.customerRefNo])
    
    

    return (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <PropertiesViewer fullWidth maxWidth={'sm'} show={showCustomerDetails} title='Customer Details' onClose={() => setShowCustomerDetails(false)} properties={showUserDetails()} />
            {onSuccessCancelTransaction && ![TRANSACTION_STATUS.CANCELLED, TRANSACTION_STATUS.PENDING_CANCELLATION].includes(status) ?
            <CancelTransactionModal
                open={showCancelModal}
                onClose={() => setShowCancelModal(false)}
                onSuccess={(transactionId) => {
                    onSuccessCancelTransaction(transactionId)
                    setShowCancelModal(false)
                }}
            /> : <></>}
            <HighlightsCard fields={getHightlights({ customerConfig, globalTransactionNumber, status, inboundId, })} customerDetails={customerConfig  as ICustomerSummary} />
            <Modal open={Boolean(showPanForm)} title={'Upload PAN'} onClose={()=> setShowPanForm(false)} >
                <CustomerPanUpload customerDetail={customerConfig as ICustomerSummary} modalClose={() => setShowPanForm(false)} onSuccess={fetchCustomer} />
            </Modal>
            <div
            // style={{margin:'-44px -18px 0 0'}}
            >
                <ButtonGroup variant="outlined" aria-label="Basic button group" >
                    <Tooltip title="Customer Details">
                        <Button onClick={() => setShowCustomerDetails(true)} color='secondary' style={{ color: 'grey' }}><Info /></Button>
                    </Tooltip>
                    { customerConfig.kycStatus !== "Y" && transactionType != "ECOM" && transactionType!= "REDEEM_AT_PVC" ?
                    <Tooltip title="Upload PAN">
                        <Button onClick={() => setShowPanForm(true)} color='secondary'><UploadIcon /></Button>
                    </Tooltip> : <></>}
                    {onSuccessCancelTransaction && ![TRANSACTION_STATUS.CANCELLED, TRANSACTION_STATUS.PENDING_CANCELLATION].includes(status) && transactionType != "ECOM" && transactionType!= "REDEEM_AT_PVC"  ?
                    <Tooltip title="Cancel Transaction">
                        <Button onClick={() => setShowCancelModal(true)} color='error'><Cancel /></Button>
                    </Tooltip> : <></>}
                </ButtonGroup>
            </div>
        </Box>
    )
}

export default HighlightsCardAndCustomerDetails
